<script setup>
import WordDiff from '@/components/offers/canvas/WordDiff.vue'

/**
 * Lines compared (D-316): the same ones plain, the changed with their words marked, the new in the
 * colour of changes, the gone struck where they stood — headings bold, list items bulleted.
 */
defineProps({ entries: { type: Array, default: () => [] } })
</script>

<template>
  <ol class="lines-compare space-y-1 text-sm" data-testid="version-compare-lines">
    <li v-for="(e, i) in entries" :key="i" :data-state="e.state"
        :class="['rounded px-2 py-0.5', e.kind === 'heading' ? 'font-semibold' : '', e.kind === 'item' ? 'list-item ml-5 list-disc' : '',
                 e.state === 'added' ? 'bg-emerald-50 text-emerald-900 dark:bg-emerald-900/30 dark:text-emerald-100' : e.state === 'removed' ? 'bg-red-50 text-red-800 line-through dark:bg-red-900/30 dark:text-red-200' : e.state === 'changed' ? 'bg-amber-50 dark:bg-amber-900/20' : '']">
      <WordDiff v-if="e.state === 'changed'" :was="e.parts.filter((p) => p.type !== 'ins').map((p) => p.text).join('')" :now="e.text" />
      <template v-else>{{ e.text || '…' }}</template>
    </li>
    <li v-if="!entries.length" class="text-faint">—</li>
  </ol>
</template>

<style>
/* The words of a changed line wherever lines are compared (the catalogue's versions, a text's history): dropped struck, added marked. */
.lines-compare .doc-words .removed { color: #b91c1c; text-decoration: line-through; }
.lines-compare .doc-words .changed { background: rgba(16, 185, 129, .18); color: #065f46; border-radius: 2px; }
.dark .lines-compare .doc-words .removed { color: #fca5a5; }
.dark .lines-compare .doc-words .changed { color: #a7f3d0; }
</style>
